import { useDraggable } from '@dnd-kit/core';
import { ReactComponent as TruckSVG } from "./TruckSVG.svg";
import { ReactComponent as TruckCargoSVG } from "./TruckCargoSVG.svg";
const DraggableTruck = ({ truck, truckClass, isReadyToLoad, haveTrailer, renderCount, isSecondRow, isOverRampRow2, showSupplier,finished }) => {
    const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
        id: `truck-${truck.BOOKINGID}-${renderCount}`,
        data: { truck },
    });

    const getTruckDisplayText = () => {
        if (showSupplier) {
            return truck?.SUPPLIER_SHORTNAMES || truck?.TRUCK_LICENSENO || truck?.BOOKINGID;
        } else {
            return truck?.TRUCK_LICENSENO || truck?.SUPPLIER_SHORTNAMES || truck?.BOOKINGID;
        }
    };

    const style = {
        transform: transform ? `translate(${transform.x}px, ${transform.y}px)` : undefined,
        opacity: isDragging ? 0.5 : 1,
    };
    let TruckIcon = TruckSVG;
    if (haveTrailer && truck.TRUCKTYPE === 2) {
        TruckIcon = renderCount === 1 ? TruckSVG : TruckCargoSVG;
    }

    const getDragRotation = () => {
        if (!isDragging) {
            return truckClass === 'truck-svg-wrapper parking-bottom'
                ? "rotate(90deg)" : "rotate(270deg)";
        }

        if (isOverRampRow2 && !isSecondRow) {
            return "rotate(0deg)";
        }

        if (isSecondRow) {
            if (isOverRampRow2) {
                return "rotate(180deg)";
            }
            return "rotate(360deg)";
        }
        return "rotate(180deg)";
    };

    const truckVisual = (
        <div
            className={ finished ? "finishedTruck" : isReadyToLoad ? "readyToLoad" : ''}
            style={{
                transform: getDragRotation(),
                transformOrigin: (truckClass !== 'truck-svg-wrapper parking-bottom'
                    ? '56% 59%'
                    : '58% 36%')
            }}
        >
            <TruckIcon />
            <span
                className="descr-for-truck"
                style={{
                    ...(truckClass === 'truck-svg-wrapper parking-bottom'
                        ? {
                            top: '20%',
                            left: '51%',
                            transform: 'translate(-50%, 50%) rotate(270deg)',
                        }
                        : truckClass === 'truck-svg-wrapper parking-top'
                            ? {
                                top: '46%',
                                left: '46%',
                                transform: 'translate(-50%, 50%) rotate(90deg)',
                            }
                            : {}),
                    textAlign: truck?.BOOKINGID ? 'center' : 'unset',
                }}
            >
                {getTruckDisplayText()}
            </span>

        </div>
    );

    return (isReadyToLoad || finished) ? truckVisual : (
        <div ref={setNodeRef} style={style} {...listeners} {...attributes}>
            {truckVisual}
        </div>
    );
};

export default DraggableTruck;
